var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('app-page-search',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"in-progress"},[_vm._v("\n    В данный момент раздел находится в стадии заполнения.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }